const common = {
  // Nav
  nav_home: 'Inicio',
  nav_books: 'Libros',
  nav_courses: 'Cursos',
  nav_mentorship: 'Mentoria SÍLEX',
  nav_webinars: 'Webinars',
  nav_about: 'Sobre',
  nav_contact: 'Contacto',
  nav_links: 'Links',
  nav_enter: 'Entrar',
  nav_my_courses: 'Mis Cursos',
  nav_community: 'Comunidad',
  nav_ranking: 'Ranking',
  nav_certificates: 'Certificados',
  // Auth
  auth_login_title: 'Accede a tu cuenta',
  auth_login_subtitle: 'Entra con email o redes sociales',
  auth_register_title: 'Crear tu cuenta',
  auth_register_subtitle: 'Regístrate para acceder a los cursos',
  auth_forgot_title: 'Recuperar contraseña',
  auth_forgot_subtitle: 'Te enviaremos un enlace a tu email',
  auth_tab_login: 'Entrar',
  auth_tab_register: 'Crear Cuenta',
  auth_email: 'Correo electrónico',
  auth_password: 'Contraseña',
  auth_name: 'Nombre completo',
  auth_confirm_password: 'Confirmar contraseña',
  auth_forgot_link: 'Olvidé mi contraseña',
  auth_btn_login: 'Entrar con Email',
  auth_btn_register: 'Crear Cuenta Gratis',
  auth_btn_forgot: 'Enviar Enlace de Recuperación',
  auth_or: 'o continúa con',
  auth_or_register: 'o regístrate con',
  auth_google: 'Continuar con Google',
  auth_facebook: 'Continuar con Facebook',
  auth_apple: 'Continuar con Apple',
  auth_back_login: '← Volver al inicio de sesión',
  auth_terms: 'Al entrar, aceptas nuestros',
  auth_terms_link: 'Términos de Uso',
  auth_privacy_link: 'Política de Privacidad',
  auth_and: 'y',
  // Livros page
  livros_hero_badge: 'Biblioteca Completa',
  livros_hero_title: 'Ebooks y Libros',
  livros_hero_subtitle: 'Conocimiento que transforma. Elige tu próximo libro y comienza tu viaje de crecimiento.',
  livros_filter_all: 'Todos',
  livros_filter_pdf: 'E-book PDF',
  livros_filter_print: 'Impreso',
  livros_search_placeholder: 'Buscar libro o tema...',
  livros_btn_buy: 'Comprar Ahora',
  livros_btn_amazon: 'Amazon',
  livros_btn_details: 'Ver Detalles',
  livros_pages: 'págs',
  livros_readers: 'lectores',
  livros_cta_title: '¿Quieres acceso a todos los libros?',
  livros_cta_subtitle: 'Suscríbete a SB Family y obtén acceso ilimitado a toda la biblioteca + cursos + mentoría grupal.',
  livros_cta_btn: 'Conocer la Suscripción',
  livros_stat_books: 'Libros Publicados',
  livros_stat_readers: 'Lectores Satisfechos',
  livros_stat_rating: 'Valoración Media',
  livros_stat_editions: 'Ediciones Revisadas',
  // Language
  lang_label: 'Idioma',
  lang_pt: 'Português',
  lang_es: 'Español',
  lang_en: 'English',
  lang_fr: 'Français',
  lang_de: 'Deutsch',
  lang_it: 'Italiano',
  lang_ja: 'Japonés',
};

export default common;
